module.exports = __webpack_public_path__ + "img/user_grey_dark_icon.156aa9ec.svg";